import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @labelName='Cardiopathie'
      @propertyName='underlyingDisease'
      @translationKey='pathology.underlying-disease'
      @allowAdditions={{true}}
      as |dropdown|
    >
      <dropdown.Item @key='amyloidosis-al' />
      <dropdown.Item @key='amyloidosis-aa' />
      <dropdown.Item @key='amyloidosis-ttr' />
      <dropdown.Item @key='hereditary-amyloidosis' />
      <dropdown.Item @key='ischemic-heart-disease' />
      <dropdown.Item @key='non-ischemic-dilated-cardiomyopathy' />
      <dropdown.Item @key='valvular-heart-disease' />
      <dropdown.Item @key='hypertrophic-cardiomyopathy' />
      <dropdown.Item @key='congenital-heart-defects' />
      <dropdown.Item @key='cardiomyopathy' />
      <dropdown.Item @key='myocardial-infarction' />
      <dropdown.Item @key='high-blood-pressure' />
      <dropdown.Item @key='valve-anomaly' />
      <dropdown.Item @key='drug-cardiotoxicity' />
      <dropdown.Item @key='heart-rhythm-disorders' />
      <dropdown.Item @key='other' />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
